import React from "react"
import { MyIcon } from "@macashipo/mlib"
import MI_Ext from "./_ext"

class MI_dashboard extends MI_Ext {
  renderIcon = () => {
    return <MyIcon configIcon="type:HiOutlineViewGrid" />
  }
}
export default MI_dashboard
